// crewEfficiencyCalculator.js

const DEFAULT_WEIGHTS = {
  attendance: 20,
  jobCompletion: 20,
  quality: 20,
  proactivity: 10,
  breakCompliance: 10,
  routeEfficiency: 10,
  revenueEfficiency: 10
};

function clamp(value, min = 0, max = 100) {
  return Math.max(min, Math.min(value, max));
}

function calculateCrewEfficiency(crew, weights = DEFAULT_WEIGHTS) {
  const score = {
    components: {},
    summaryScore: 0,
    crewId: crew.crewId
  };

  const shiftsWorked = crew.shiftsAssigned - crew.daysAbsent;

  // Attendance score (based on lateness and absences)
  const latePenalty = (crew.daysLate / crew.shiftsAssigned) * 0.5 + (crew.avgMinutesLate / 30) * 0.5;
  const attendancePenalty = clamp((crew.daysAbsent / crew.shiftsAssigned) + latePenalty, 0, 1);
  const attendanceScore = clamp(100 * (1 - attendancePenalty));

  // Job completion
  const jobCompletionScore = clamp((crew.jobsCompleted / crew.jobsAssigned) * 100);

  // Quality: combines review score and photo compliance
  const qualityScore = clamp(((crew.avgReviewScore / 5) * 0.6 + (crew.photoCompliancePct / 100) * 0.4) * 100);

  // Proactivity (rework penalty and issues handled)
  const reworkPenalty = clamp((crew.reworks / crew.jobsCompleted) * 100);
  const proactivityScore = clamp(100 - reworkPenalty);

  // Break compliance
  const breakMissRate = (crew.breaksMissed + crew.lunchesMissed) / crew.shiftsAssigned;
  const breakScore = clamp(100 - breakMissRate * 100);

  // Route efficiency
  const mileageDelta = crew.totalMilesDriven - crew.expectedMiles;
  const mileagePenalty = clamp((mileageDelta / crew.expectedMiles) * 100);
  const routeScore = clamp(100 - mileagePenalty);

  // Revenue efficiency
  const totalHours = crew.crewCost / 20; // assume $20/hr avg baseline if not exact
  const actualDollarPerHour = crew.valueGenerated / totalHours;
  const revenueRatio = actualDollarPerHour / crew.targetDollarPerHourRatio;
  const revenueScore = clamp(Math.min(revenueRatio, 1) * 100);

  score.components.attendance = { score: attendanceScore };
  score.components.jobCompletion = { score: jobCompletionScore };
  score.components.quality = { score: qualityScore };
  score.components.proactivity = { score: proactivityScore };
  score.components.breakCompliance = { score: breakScore };
  score.components.routeEfficiency = { score: routeScore };
  score.components.revenueEfficiency = {
    score: revenueScore,
    dollarPerHour: actualDollarPerHour
  };

  score.summaryScore = clamp(
    (attendanceScore * (weights.attendance / 100)) +
    (jobCompletionScore * (weights.jobCompletion / 100)) +
    (qualityScore * (weights.quality / 100)) +
    (proactivityScore * (weights.proactivity / 100)) +
    (breakScore * (weights.breakCompliance / 100)) +
    (routeScore * (weights.routeEfficiency / 100)) +
    (revenueScore * (weights.revenueEfficiency / 100))
  );

  return score;
}

module.exports = { calculateCrewEfficiency, DEFAULT_WEIGHTS };
